<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>个人词典</span>
                        <h1>使用个人词典来自定义Trinka</h1>
                        <p>使用个人词典来避免使用新术语时的拼写提醒。只需添加Trinka不知道的单词，例如品牌名称或新技术，Trinka就会一直记住它们。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=CN" id="autoEditGetStart" target="_blank">开始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/Personal-Dictionary.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/MyDicitonayThumbnail.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">查看简单的演练视频，立即开始构建您的个人词典。</p>
                        <p style="margin-bottom: 10px;">这个详细的分步教程可帮助您充分利用Trinka的强大功能。如果您有更多问题，请在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link remove-space">此处</a>浏览我们的常见问题解答。</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="keyFeatureSection">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Trinka个人词典的主要特点</h2>
                    <div class="HeadingSubLine"></div>
                    <p style="margin-bottom: 40px;">摆脱不必要的文字标记，让您的写作流畅自然。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="toolbox_img_content">
                            <img src="assets/images/correct-spelling.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="toolbox_text_content">
                            <h3>词的分类</h3>
                            <p>您可以将个人词典中的单词分类为正确的拼写、技术程序名称、生物学名称、产品名称等。随着您使用的增多，Trinka会变得更好。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-7">
                        <div class="toolbox_text_content">
                            <h3>调整大小写敏感度</h3>
                            <p>您甚至可以设置Trinka，在匹配大小写时决定是否忽略您的个人词典和术语。</p>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5">
                        <div class="toolbox_img_content">
                            <img src="assets/images/case-sensitive.png" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5">
                        <div class="toolbox_img_content">
                            <img src="assets/images/american-english.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7">
                        <div class="toolbox_text_content">
                            <h3>选择英文类型</h3>
                            <p>Trinka允许您设置是否在英语类型匹配时忽略添加的术语，或者全部忽略。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-7">
                        <div class="toolbox_text_content">
                            <h3>跨平台同步</h3>
                            <p>您添加到词典中的所有单词会在所有平台上实时自动同步，包括云编辑器、微软Word插件以及浏览器插件。您的Trinka词典能在任何地方使用。</p>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5">
                        <div class="toolbox_img_content noBackgroundColor syncAcrossImages">
                            <img src="assets/images/SyncAcrossPlatforms.png" alt="" class="img-fluid" style="max-width: 300px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5">
                        <div class="toolbox_img_content noBackgroundColor">
                            <img src="assets/images/MyDictionary_Brand-tone.png" alt="" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7">
                        <div class="toolbox_text_content">
                            <h3>保持品牌用语的一致
                                <span>企业</span>
                            </h3>
                            <p>添加您单位的词典和新术语来个性化您的写作助手，在所有通信中保持品牌用语的一致。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka个人词典的主要特点</h2>
                        <div class="HeadingSubLine"></div>
                        <p>摆脱不必要的文字标记，让您的写作流畅自然。
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/BuildYourVeryOwnDictionary.png" alt="">
                        <h3>Build Your Very Own Dictionary</h3>
                        <p>Create your own dictionary by adding terms as you use Trinka or just add them all in one go. You
                            can edit and delete words any time.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/CategorizationOfWords.png" alt="">
                        <h3>Categorization of Words</h3>
                        <p>You can organize the words you add to your dictionary as correct spellings, technical procedure names,
                            biological names, product names, etc. Trinka gets better as you do.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="assets/images/AdjustCaseSensitivity.png" alt="">
                        <h3>Adjust Case Sensitivity</h3>
                        <p>You can even control whether Trinka should ignore your dictionary terms when they match casing or
                            regardless.
                        </p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="assets/images/ChooseEnglishType.png" alt="">
                        <h3>Choose English Type</h3>
                        <p>Trinka lets you control whether added terms are ignored when the English type matches or are ignored
                            regardless.
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <span>Enterprise</span>
                        <img src="assets/images/MaintainBrandTone.png" alt="">
                        <h3>Maintain Brand Tone</h3>
                        <p>Add your organization lexicon and new terms to stay on brand across all communications & personalize
                            your writing assistance. </p>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>Advanced Controls</h3>
                        <p>With advanced controls, you can search for words and sort them too based on recent additions and
                            alphabetical order.</p>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

    <div class="forpersonlized_sections">
        <p>使用自定义词典来个性化您的写作</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">开始使用</a>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常见问题</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        其他人可以访问我添加的单词吗？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的个人字典是独有的，其他人不能访问或使用它。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">我在哪里可以找到个人词典？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在您的
                                            <a href="https://cloud.trinka.ai/dashboard/profile" target="_blank" class="remove-space">帐户设置</a>中，在“写作设置”部分你可以找到“我的词典”按钮。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以与其他帐户共享个人字典吗？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您的个人字典是独有的，不能与其他帐户共享。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以下载个人词典吗？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前您无法下载个人字典，我们将很快添加此功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        使用个人词典来自定义Trinka
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>将Trinka无法识别的单词添加到您个人词典中，例如品牌名称或新技术术语，以避免拼写警示。
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他应用程序中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold; font-size: 18px">Trinka</span>云</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Others_App_MSWord.svg" alt="">
                                            <h3>
                                                <span class="OpenSansFonts" style="font-weight: bold;font-size: 18px;">Word</span>
                                                <br />插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/other_Apps_browser.svg" alt="">
                                            <h3>浏览器插件</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="assets/images/Other_Apps_enterprise.svg" alt="">
                                            <h3 style="margin: 0 0 -2px 0;">企业</h3>
                                            <span class="OpenSansFonts" style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="//player.bilibili.com/player.html?aid=898510882&bvid=BV1mN4y1T7nD&cid=777872652&page=1"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>